import Vue from 'vue';
import Component from 'vue-class-component';
import {
  mdiAccountCancel,
  mdiAccountCircle,
  mdiAlarm,
  mdiArrowDownThick,
  mdiArrowUpThick,
  mdiBookRefresh,
  mdiCertificate,
  mdiCloseCircle,
  mdiClose,
  mdiCheckBold,
  mdiChevronDown,
  mdiChevronUp,
  mdiCursorMove,
  mdiDelete,
  mdiDotsVertical,
  mdiFileAccount,
  mdiFileClock,
  mdiFileDocumentOutline,
  mdiFileDownload,
  mdiFileDownloadOutline,
  mdiFileExport,
  mdiFileHidden,
  mdiFolderOutline,
  mdiFolderEditOutline,
  mdiFolderOpenOutline,
  mdiFormTextbox,
  mdiGavel,
  mdiInformation,
  mdiLock,
  mdiLockOpen,
  mdiBookLock,
  mdiBookLockOpenOutline,
  mdiKeyboardReturn,
  mdiMagnify,
  mdiMenuDown,
  mdiMessageDraw,
  mdiOpenInNew,
  mdiPaperclip,
  mdiPencil,
  mdiPlusCircleOutline,
  mdiRenameBox,
  mdiRestart,
  mdiSeal,
  mdiSetLeft,
  mdiViewList,
  mdiViewStream,
  mdiPin,
  mdiPinOutline,
  mdiMinus,
  mdiEye,
  mdiFilterVariant,
  mdiFolderMoveOutline,
  mdiFolderStar,
  mdiPrinter,
  mdiArrowRightBold,
  mdiPackageDown,
  mdiPackageUp,
  mdiLabel,
  mdiSquare,
  mdiStar,
  mdiStarOutline,
  mdiMemory,
  mdiUpdate,
  mdiTag,
  mdiUnfoldMoreHorizontal,
  mdiUnfoldLessHorizontal,
  mdiContentSave,
  mdiCheckCircleOutline,
  mdiMinusCircleOutline,
  mdiMinusCircle,
  mdiCalendarRange,
  mdiTextSearch,
  mdiPlaylistEdit,
  mdiFileDocumentRemoveOutline,
  mdiFileDocumentPlusOutline,
  mdiCalendarClockOutline,
  mdiCheckCircle,
  mdiFileUploadOutline,
  mdiTransfer,
  mdiTimerSandFull,
  mdiArrowDown,
  mdiArrowUp,
} from '@mdi/js';

@Component
export default class IconsMixin extends Vue {
  get icons(): Record<string, any> {
    return {
      mdiAccountCancel,
      mdiAccountCircle,
      mdiAlarm,
      mdiArrowDownThick,
      mdiArrowUpThick,
      mdiBookRefresh,
      mdiCertificate,
      mdiCloseCircle,
      mdiClose,
      mdiCheckBold,
      mdiChevronDown,
      mdiChevronUp,
      mdiCursorMove,
      mdiDelete,
      mdiDotsVertical,
      mdiFileAccount,
      mdiFileClock,
      mdiFileDocumentOutline,
      mdiFileDownload,
      mdiFileDownloadOutline,
      mdiFileExport,
      mdiFileHidden,
      mdiFolderOutline,
      mdiFolderEditOutline,
      mdiFolderOpenOutline,
      mdiFormTextbox,
      mdiGavel,
      mdiInformation,
      mdiLock,
      mdiLockOpen,
      mdiBookLock,
      mdiBookLockOpenOutline,
      mdiKeyboardReturn,
      mdiMagnify,
      mdiMenuDown,
      mdiMessageDraw,
      mdiOpenInNew,
      mdiPaperclip,
      mdiPencil,
      mdiPlusCircleOutline,
      mdiRenameBox,
      mdiRestart,
      mdiSeal,
      mdiSetLeft,
      mdiViewList,
      mdiViewStream,
      mdiPin,
      mdiPinOutline,
      mdiMinus,
      mdiEye,
      mdiFilterVariant,
      mdiFolderMoveOutline,
      mdiFolderStar,
      mdiPrinter,
      mdiArrowRightBold,
      mdiPackageDown,
      mdiPackageUp,
      mdiLabel,
      mdiSquare,
      mdiStar,
      mdiStarOutline,
      mdiMemory,
      mdiUpdate,
      mdiTag,
      mdiUnfoldMoreHorizontal,
      mdiUnfoldLessHorizontal,
      mdiContentSave,
      mdiCheckCircleOutline,
      mdiMinusCircleOutline,
      mdiMinusCircle,
      mdiCalendarRange,
      mdiTextSearch,
      mdiPlaylistEdit,
      mdiFileDocumentRemoveOutline,
      mdiFileDocumentPlusOutline,
      mdiCalendarClockOutline,
      mdiCheckCircle,
      mdiFileUploadOutline,
      mdiTransfer,
      mdiTimerSandFull,
      mdiArrowDown,
      mdiArrowUp,
    };
  }

  public getSvgIcon(key: string) {
    return this.icons[key];
  }
}
